import { animate, style, transition, trigger } from '@angular/animations';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NetworkStatusService } from 'app/core/pwa/network-status.service';

/**
 * Tells the user that the app lost the network, so the screen they are reading is understood as a
 * snapshot rather than as live data.
 */
@Component({
    selector: 'pwa-offline-indicator',
    templateUrl: './offline-indicator.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [MatIconModule],
    animations: [
        trigger('slideDown', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-100%)' }),
                animate('250ms cubic-bezier(0, 0, 0.2, 1)', style({ opacity: 1, transform: 'none' })),
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-100%)' })),
            ]),
        ]),
    ],
})
export class PwaOfflineIndicatorComponent {
    protected readonly online = inject(NetworkStatusService).online;
}
